import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@enlighten/design-system/dist/Box';
import Stack from '@enlighten/design-system/dist/Stack';
import Image from 'next/image';
import ImgPc from '../../assets/images/hanwha/section-3-img.png';
import ImgMobile from '../../assets/images/hanwha/section-3-img-m.png';
const alt = '';
export default function Section3() {
    return (_jsxs(Stack, { justifyContent: "center", alignItems: "center", padding: { xs: '40px 24px 82px', md: '70px 24px 140px' }, children: [_jsx(Box, { display: { xs: 'none', md: 'block' }, maxWidth: 920, sx: {
                    '& img': {
                        width: '100%',
                        height: 'auto',
                    },
                }, children: process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
                    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true' ? (_jsx(Image, { src: ImgPc, alt: alt, width: 920 })) : (_jsx("img", { src: ImgPc, alt: alt, width: 920 })) }), _jsx(Box, { display: { xs: 'block', md: 'none' }, sx: {
                    '& img': {
                        width: '100%',
                        height: 'auto',
                    },
                }, children: process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
                    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true' ? (_jsx(Image, { src: ImgMobile, alt: alt })) : (_jsx("img", { src: ImgMobile, alt: alt })) })] }));
}
